export const HomePageConstants = {
    REQUEST_ADD_ORG: 'REQUEST_ADD_ORG',
    RECEIVE_ADD_ORG: 'RECEIVE_ADD_ORG',
    ADD_ORG_ERROR: 'ADD_ORG_ERROR',

    REQUEST_GET_ORG: 'REQUEST_GET_ORG',
    RECEIVE_GET_ORG: 'RECEIVE_GET_ORG',
    GET_ORG_ERROR: 'GET_ORG_ERROR',

    REQUEST_GET_COUNTRY_LIST:'REQUEST_GET_COUNTRY_LIST',
    RECEIVE_GET_COUNTRY_LIST:'RECEIVE_GET_COUNTRY_LIST',
    GET_COUNTRY_LIST_ERROR:'GET_COUNTRY_LIST_ERROR',
}



// WEBPACK FOOTER //
// ./src/_constants/HomePage/homePage.constants.js